/**
 * Site Footer
 *
 * Minimal footer with legal links and contact email. Used on main pages
 * (not vote pages where space is at a premium).
 */

import { Link } from 'react-router-dom';

export const Footer = () => (
  <footer style={{ background: '#1A1A1A' }}>
    <div className="max-w-5xl mx-auto px-6 py-6 text-center text-xs">
      <div className="mb-2">
        <Link
          to="/terms"
          className="transition-colors hover:text-white"
          style={{ color: 'rgba(255,255,255,0.5)' }}
        >
          Terms of Service
        </Link>
        <span className="mx-2" style={{ color: 'rgba(255,255,255,0.3)' }}>
          &middot;
        </span>
        <Link
          to="/privacy"
          className="transition-colors hover:text-white"
          style={{ color: 'rgba(255,255,255,0.5)' }}
        >
          Privacy Policy
        </Link>
      </div>
      <div>
        <span style={{ color: 'rgba(255,255,255,0.4)' }}>Need help?</span>{' '}
        <a
          href="mailto:contact@spreadsheetarena.ai"
          className="transition-colors hover:text-white"
          style={{ color: 'rgba(255,255,255,0.5)' }}
        >
          contact@spreadsheetarena.ai
        </a>
      </div>
    </div>
  </footer>
);
